import React from 'react';
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import { Link } from 'react-router-dom';
import Title from 'components/text/Title';
import styled from 'styled-components';

const ContentContainer = styled(Row)`
  border: 1px solid #d3d3d3;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 8px;
  padding: 8px;
`;

class DashboardItem extends React.PureComponent {
  render() {
    const { dashboard, organization } = this.props;
    return (
      <ContentContainer>
        <Col xs={4}>
          <img src={dashboard.icon} alt="dashboard-icon" height="65" />
        </Col>
        <Col xs={18}>
          <Title>{dashboard.name}</Title>
        </Col>
        <Col xs={2}>
          <Link to={`/dashboards/${dashboard._id}/${organization._id}`} target="_blank">
            view
          </Link>
        </Col>
      </ContentContainer>
    );
  }
}

export default DashboardItem;



// WEBPACK FOOTER //
// ./src/components/common/DashboardItem/index.js